export const useLodashDebounce = <T extends (...args: any) =>any>(
  callback: T,
  wait: number,
):(...args:any)=>any => callback
